<template>
  <div :class="`card card--${type}`" :style="image ? `background-image: url('${image.url}')` : null">
    <h3
      class="card__title"
      v-html="stripP(title)"
    />
    <div class="card__subtitle">
      <p v-html="subtitle"></p>
      <div
        class="card__link"
        @click="handleAction()"
      >
        <component
          :is="icon"
          v-if="icon && type !== 'small'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as components from '@/icons'
import actionHandler from '@/mixins/actionHandler.mixin'
import { stripP } from '@/filters/text'
export default {
  components: {
    ...components
  },
  mixins:[actionHandler],
  props: {
    image: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    stripP: stripP
  }
}
</script>

<style lang="scss">
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: $card-width-large;
  min-height: $card-height-large;
  padding: $card-padding;
  background-color: $card-background-odd;
  border-radius: $card-radius;
  scroll-snap-align: start;
  scroll-margin: $card-padding;
  background-size: cover;
  background-repeat: no-repeat;
  &--small {
    width: max-content;
    min-width: $card-width-small;
    min-height: $card-height-small;
  }
  & + & {
    margin-left: $card-space-between;
  }
  &:nth-of-type(even) {
    background-color: $card-background-even;
  }
  &__title {
    // max-width: $card-text-width;
    color: $card-title-color;
  }
  &__subtitle {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    color: $card-subtitle-color;
  }
  &__link {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  svg {
    fill: $card-arrow;
    width: $card-icon-width;
  }
}
</style>

<docs>
  ## Large card (standard)
  ```vue
  <Card title="title" subtitle="subtext" icon="arrow-right" />
  ```
  ## Small card
  ```vue
    <Card type="small" title="title" icon="arrow-right" />
  ```
  ```scss
    // Variable defaults:
    $cards-overlap: rem(-40);
    $card-width-small: rem(140);
    $card-width-large: rem(300);
    $card-height-small: rem(90);
    $card-height-large: rem(244);
    $card-radius: 2px;
    $card-padding: rem(20);
    $card-space-between: rem(10);
    $card-background-odd: color(dark);
    $card-background-even: $card-background-odd;
    $card-title-color: color(light);
    $card-subtitle-color: color(light);
    $card-text-width: rem(188);
    $card-arrow: color(dark);
    $card-icon-width: $default-icon-width; // 1rem
  ```
</docs>
